/* ─────────────────────────────────────────────────────────────
   Caalburn  –  Master product data
   ───────────────────────────────────────────────────────────── */

export const PRODUCTS = [

  /* ── WHEY PROTEINS ─────────────────────────────────── */
  {
    id: "whey-protein", name: "Whey Protein",
    image: "/images/whey-protein.png",
    tagline: "100% Whey Concentrate + Isolate", subtitle: "Pure Muscle. Pure Performance.",
    category: "Whey Proteins", badge: "Pro Series", accentColor: "#8b5cf6",
    protein: "25g", calories: "121", carbs: "3.30g", bcaa: "6.56g", servingSize: "33g",
    flavors: ["Chocolate", "Kesar Kulfi", "Kesar Badam"], sizes: ["2KG", "5KG", "10KG"],
    suggestedUsage: "75 Gram approx.(2 scoop) in 180-200ml of water or milk twice a day or as recommended by a licensed nutritionist.",
    description: "The most reliable whey protein concentrate and whey protein isolate have been sourced from quality international producers and used as the building blocks of Caalburn Whey. Team Caalburn researched this zero-sugar formula to help body builders and athletes achieve a lean muscular body.",
    whenToTake: [
      { label: "Post Workout",  text: "Consume within 30 minutes after training for optimal muscle protein synthesis." },
      { label: "Between Meals", text: "Use as a high-protein snack between meals to meet daily protein requirements." },
    ],
    features: [
      { title: "25g Protein",        body: "Per 32g serving size." },
      { title: "Ultra Whey",         body: "Single protein source is ultra whey protein." },
      { title: "6.56g BCAA",         body: "Naturally derived branched chain amino acids per serving." },
      { title: "Digestive Enzymes",  body: "Enhanced with digestive enzymes and dietary fibres for easy digestion." },
      { title: "Zero Sugar",         body: "Zero sugar formula for lean muscle support." },
      { title: "Easy Mix",           body: "Mixes effortlessly with a blender, shaker or spoon." },
    ],
    nutritionRows: [
      { name: "Energy",             unit: "kcal", water: "121.0", milk: "366.00", rda: "4.43%"  },
      { name: "Total Carbohydrate", unit: "g",    water: "3.30",  milk: "10.00",  rda: "—"      },
      { name: "Protein",            unit: "g",    water: "25.00", milk: "76.00",  rda: "41.67%" },
      { name: "Total Fat",          unit: "g",    water: "0.83",  milk: "2.50",   rda: "2.77%"  },
      { name: "Calcium",            unit: "mg",   water: "74.25", milk: "225.00", rda: "12.37%" },
      { name: "Potassium",          unit: "mg",   water: "82.50", milk: "250.00", rda: "2.2%"   },
      { name: "Phosphorus",         unit: "mg",   water: "49.50", milk: "150.00", rda: "8.25%"  },
    ],
  },

  {
    id: "isopure", name: "Isopure",
    image: "/images/isopuree.png",
    tagline: "100% Whey Isolate", subtitle: "The True Strength of Whey",
    category: "Whey Proteins", badge: "Pro Series", accentColor: "#10b981",
    protein: "31.5g", calories: "132.5", carbs: "3.3g", bcaa: "6.56g", servingSize: "37g",
    flavors: ["Chocolate", "Kesar Kulfi", "Kesar Badam"], sizes: ["2LBS", "4LBS"],
    suggestedUsage: "75 Gram approx.(2 scoop) in 180-200ml of water or milk twice a day or as recommended by a licensed nutritionist.",
    description: "Caalburn 100% Whey Isopure is rapidly absorbed and delivers a fast supply of amino acids to drive protein synthesis. It is dually processed using scientifically advanced micro filtration to ensure an isolated whey protein that contains one of the highest percentages of protein with almost zero fat and lactose.",
    whenToTake: [
      { label: "Post Workout", text: "Consume within 30 minutes after your workout for optimal muscle recovery." },
      { label: "Morning",      text: "Have a serving first thing in the morning to kickstart muscle protein synthesis." },
    ],
    features: [
      { title: "81.10% Protein", body: "By weight — 30g of protein per 37g serving size." },
      { title: "Ultra Whey",     body: "Single protein source is ultra whey isolate." },
      { title: "6.56g BCAA",     body: "Naturally derived branched chain amino acids per serving." },
      { title: "Dietary Fiber",  body: "With digestive dietary fiber inulin." },
      { title: "Near Zero Fat",  body: "Almost zero fat and lactose content." },
      { title: "Easy Mix",       body: "Mixes effortlessly with a blender, shaker or spoon." },
    ],
    nutritionRows: [
      { name: "Energy",             unit: "kcal", water: "132.50", milk: "358.10", rda: "4.85%"  },
      { name: "Total Carbohydrate", unit: "g",    water: "3.30",   milk: "10.00",  rda: "—"      },
      { name: "Protein",            unit: "g",    water: "30.0",   milk: "81.08",  rda: "50%"    },
      { name: "Total Fat",          unit: "g",    water: "0.50",   milk: "1.35",   rda: "1.66%"  },
      { name: "Calcium",            unit: "mg",   water: "50.0",   milk: "135.0",  rda: "8.33%"  },
      { name: "Potassium",          unit: "mg",   water: "40.0",   milk: "108.1",  rda: "2.39%"  },
      { name: "Phosphorus",         unit: "mg",   water: "40.0",   milk: "135.1",  rda: "2.39%"  },
    ],
  },

  /* ── WEIGHT GAINER ─────────────────────────────────── */
  {
    id: "hulk", name: "Hulk",
    image: "/images/HULLKK.jpeg",
    tagline: "Premium Weight Gainer", subtitle: "Explosive Size & Power",
    category: "Weight Gainer", badge: "Elite Series", accentColor: "#3b82f6",
    protein: "27g", calories: "564", carbs: "72.5g", bcaa: "5.5g", servingSize: "150g",
    flavors: ["Double rich chocolate", "Caffe mocha", "Kesar kulfi", "Birthday cake", "Icecream sundae", "Mango alphanso", "Strawberry delight"], sizes: ["1KG",  "2.8KG", "5KG"],
    suggestedUsage: "75 gram approx.(2 scoop) in 180-200ml of water or milk twice a day or as recommended by a licensed nutritionist.",
    description: "Caalburn Hulk Mass Gainer provides vitamins, minerals, amino acids, high quality protein and carbs to help fuel your muscles, preserve muscle energy supplies and help to reduce muscle breakdown during intense exercise. Each 150g serving provides a 54g dose of premium muscle building protein made from 5 unique sources.",
    whenToTake: [
      { label: "Post Workout",      text: "Use as your post workout recovery shake for maximum muscle repair." },
      { label: "High Protein Meal", text: "Use as a high protein meal between meals to support continuous growth." },
    ],
    features: [
    { title: "564 Calories",       body: "Per 150g serving with water." },
    { title: "72.5g Carbs",        body: "Per 150g serving with water." },
    { title: "27g Protein",        body: "Per 150g serving for muscle building." },
    { title: "24 Vitamins & Minerals", body: "Complete micronutrient support." },
    { title: "Digestive Enzymes",  body: "Enhanced with amylase, papain and dietary fibres for easy digestion." },
    { title: "Easy Mix",           body: "Mixes effortlessly with a blender, shaker or spoon." },
  ],
    nutritionRows: [
      { name: "Energy",             unit: "kcal", water: "282.0",   milk: "327.00", rda: "20.66%" },
      { name: "Total Carbohydrate", unit: "g",    water: "36.25",   milk: "38.00",  rda: "—"      },
      { name: "Protein",            unit: "g",    water: "13.50",   milk: "15.4",   rda: "90.00%" },
      { name: "Total Fat",          unit: "g",    water: "2.4",     milk: "4.6",    rda: "4.61%"  },
      { name: "Calcium",            unit: "mg",   water: "300.00",  milk: "384.75", rda: "100%"   },
      { name: "Vitamin A",          unit: "IU",   water: "1000.00", milk: "1076.5", rda: "100%"   },
      { name: "Vitamin C",          unit: "mg",   water: "20.00",   milk: "20.00",  rda: "100%"   },
    ],
  },

  {
    id: "masculus-mass", name: "Masculus Mass",
    image: "/images/MMM.jpeg",
    tagline: "High Protein Mass Gainer", subtitle: "Build Serious Size & Strength",
    category: "Weight Gainer", badge: "Elite Series", accentColor: "#eab308",
    protein: "61.3g", calories: "756", carbs: "70.8g", bcaa: "5.5g", servingSize: "150g",
    flavors: ["Double rich chocolate", "Caffe mocha", "Kesar kulfi", "Birthday cake", "Icecream sundae", "Mango alphanso", "Strawberry delight"], sizes: ["1KG", "2.8KG", "5KG"],
    suggestedUsage: "75 gram approx.(2 scoop) in 180-200ml of water or milk twice a day or as recommended by a licensed nutritionist.",
    description: "Putting on size requires a balance of heavy training and quality nutrition. Caalburn Masculus Mass Gainer provides vitamins, minerals, amino acids, high quality protein and carbs to help fuel your muscles, preserve muscle energy supplies and help to reduce muscle breakdown during intense exercise.",
    whenToTake: [
      { label: "Post Workout",      text: "Use as your post workout recovery shake for maximum muscle repair." },
      { label: "High Protein Meal", text: "Use as a high protein meal between meals to support muscle growth." },
    ],
 features: [
    { title: "756 Calories",       body: "Per 150g serving with water." },
    { title: "70.8g Carbs",        body: "Per 150g serving with water." },
    { title: "61.3% Protein",      body: "High protein by weight for serious mass gains." },
    { title: "2.5g Creatine",      body: "Added for increased strength and power." },
    { title: "1.8g Dietary Fibre", body: "Supports better digestion and gut health." },
    { title: "Digestive Enzymes",  body: "Enhanced with amylase, papain and dietary fibres for easy digestion." },
    { title: "Easy Mix",           body: "Mixes effortlessly with a blender, shaker or spoon." },
  ],
    nutritionRows: [
      { name: "Energy",             unit: "kcal", water: "282.0",   milk: "327.00", rda: "20.66%" },
      { name: "Total Carbohydrate", unit: "g",    water: "36.25",   milk: "38.00",  rda: "—"      },
      { name: "Protein",            unit: "g",    water: "13.50",   milk: "15.4",   rda: "90.00%" },
      { name: "Total Fat",          unit: "g",    water: "2.4",     milk: "4.6",    rda: "4.61%"  },
      { name: "Calcium",            unit: "mg",   water: "300.00",  milk: "354.00", rda: "100%"   },
      { name: "Vitamin A",          unit: "IU",   water: "1000.00", milk: "1076.5", rda: "100%"   },
      { name: "Vitamin C",          unit: "mg",   water: "20.00",   milk: "20.00",  rda: "100%"   },
    ],
  },

  /* ── MASS GAINER ───────────────────────────────────── */
  {
    id: "transformer", name: "Transformer",
    image: "/images/transformer.jpeg",
    tagline: "Evolution Balanced Sports Nutrition", subtitle: "Maximum Gains In Lean Mass And Performance",
    category: "Mass Gainer", badge: "Elite Series", accentColor: "#f97316",
    protein: "21g", calories: "736", carbs: "130g", bcaa: "6.05g", servingSize: "150g",
    flavors: ["Double rich chocolate", "Caffe mocha", "Kesar kulfi", "Birthday cake", "Icecream sundae", "Mango alphanso", "Strawberry delight"], sizes: ["1KG", "2.8KG", "5KG"],
    suggestedUsage: "75 Gram approx.(2 scoop) in 180-200ml of water or milk twice a day or as recommended by a licensed nutritionist.",
    description: "Without enough of the right carbs, quality proteins and healthy fats to complement your training you want to achieve maximum gain. The Caalburn Mass Transformer provides a ratio of nutrients known to accelerate increase in lean mass and exercise performance — each 150g serving at 778 calories, 54g of protein and 130g of important carbs.",
    whenToTake: [
      { label: "Between Meals", text: "Drink 75-150gm serving between meals to maintain positive nitrogen balance and support a high calorie diet." },
      { label: "Post Workout",  text: "Begin drinking 75-150gm serving 30 to 45 minutes following exercise to support maximum recovery." },
      { label: "Before Bed",    text: "Drink 75-150gm serving about 45–60 minutes before bed to provide nutrients to recovering muscle throughout the night." },
    ],
  features: [
    { title: "736 kcal",          body: "Per 150g serving with water." },
    { title: "21g Protein",       body: "Per 150g serving." },
    { title: "2.5g Creatine",     body: "Added for strength and power." },
    { title: "1g Glutamine",      body: "For faster recovery and muscle protection." },
    { title: "Digestive Fibres",  body: "Enhanced with dietary fibres (inulin) for easy digestion." },
    { title: "Balanced Formula",  body: "Ideal ratio for lean mass gains and performance." },
    { title: "Easy Mix",          body: "Mixes effortlessly with a blender, shaker or spoon." },
  ],
    nutritionRows: [
      { name: "Energy",             unit: "kcal", water: "282.0",   milk: "327.00", rda: "20.86%" },
      { name: "Total Carbohydrate", unit: "g",    water: "36.25",   milk: "38.00",  rda: "—"      },
      { name: "Protein",            unit: "g",    water: "13.50",   milk: "15.4",   rda: "90.00%" },
      { name: "Total Fat",          unit: "g",    water: "2.4",     milk: "4.6",    rda: "4.61%"  },
      { name: "Calcium",            unit: "mg",   water: "300.00",  milk: "384.75", rda: "100%"   },
      { name: "Vitamin A",          unit: "IU",   water: "1000.00", milk: "1076.5", rda: "100%"   },
      { name: "Vitamin C",          unit: "mg",   water: "20.00",   milk: "20.00",  rda: "100%"   },
    ],
  },

  /* ── PRE WORKOUTS ──────────────────────────────────── */
  {
    id: "phantom", name: "Phantom",
    image: "/images/phantom.png",
    tagline: "Advanced Pre-Workout Formula", subtitle: "Unleash Your True Potential",
    category: "Pre Workouts", badge: "Pro Series", accentColor: "#ec4899",
    protein: "3g", calories: "45", carbs: "6g", bcaa: "2g", servingSize: "15g",
    flavors: ["Blue Raspberry", "Watermelon", "Green Apple"], sizes: ["150g", "300g"],
    suggestedUsage: "Mix 1 scoop (15g) in 250ml cold water and consume 20-30 minutes before workout.",
    description: "Caalburn Phantom is an advanced pre-workout formula engineered to maximize training intensity, focus and endurance. Packed with scientifically dosed ingredients to fuel explosive workouts and delay fatigue.",
    whenToTake: [{ label: "Pre Workout", text: "Consume 20-30 minutes before your training session for maximum effect." }],
    features: [
      { title: "Energy Boost",   body: "Sustained energy without crashes." },
      { title: "Mental Focus",   body: "Enhanced mental clarity and focus during training." },
      { title: "Endurance",      body: "Delays muscle fatigue for longer, harder sessions." },
      { title: "Pump Formula",   body: "Nitric oxide boosters for massive muscle pumps." },
      { title: "Fast Absorbing", body: "Rapid absorption formula for quick onset." },
      { title: "Easy Mix",       body: "Mixes effortlessly with cold water." },
    ],
    nutritionRows: [
      { name: "Energy",    unit: "kcal", water: "45",  milk: "—", rda: "1.6%" },
      { name: "Protein",   unit: "g",    water: "3",   milk: "—", rda: "5%"   },
      { name: "Carbs",     unit: "g",    water: "6",   milk: "—", rda: "—"    },
      { name: "Caffeine",  unit: "mg",   water: "200", milk: "—", rda: "—"    },
    ],
  },

  {
    id: "l-glutamine", name: "L-Glutamine",
    image: "/images/lglutamine.png",
    tagline: "Pure Glutamine Powder", subtitle: "Accelerate Recovery. Protect Muscle.",
    category: "Pre Workouts", badge: "Pro Series", accentColor: "#06b6d4",
    protein: "5g", calories: "20", carbs: "0g", bcaa: "—", servingSize: "5g",
    flavors: ["Unflavored"], sizes: ["150g", "300g", "500g"],
    suggestedUsage: "Mix 1 scoop (5g) in 250ml of water or juice. Take post-workout or before bed.",
    description: "Caalburn L-Glutamine is pure pharmaceutical grade glutamine powder. It is the most abundant amino acid in muscle tissue, playing a critical role in muscle recovery, immune function and gut health.",
    whenToTake: [
      { label: "Post Workout", text: "Take immediately after training to kickstart muscle recovery." },
      { label: "Before Bed",   text: "Take before bed to support overnight muscle repair and immune function." },
    ],
    features: [
      { title: "5g Pure Glutamine", body: "Per serving — 100% pharmaceutical grade." },
      { title: "Muscle Recovery",   body: "Speeds up post-workout muscle repair." },
      { title: "Immune Support",    body: "Supports immune system function." },
      { title: "Gut Health",        body: "Promotes healthy gut lining and digestion." },
      { title: "Zero Sugar",        body: "Completely sugar and calorie free." },
      { title: "Unflavored",        body: "Mix in any shake or drink without altering taste." },
    ],
    nutritionRows: [
      { name: "Energy",      unit: "kcal", water: "20", milk: "—", rda: "—"    },
      { name: "L-Glutamine", unit: "g",    water: "5",  milk: "—", rda: "—"    },
      { name: "Protein",     unit: "g",    water: "5",  milk: "—", rda: "8.3%" },
    ],
  },

  {
    id: "l-arginine-pre", name: "L-Arginine",
    image: "/images/larginine.png",
    tagline: "Nitric Oxide Booster", subtitle: "Maximum Pump. Maximum Power.",
    category: "Pre Workouts", badge: "Pro Series", accentColor: "#f43f5e",
    protein: "3g", calories: "15", carbs: "0g", bcaa: "—", servingSize: "3g",
    flavors: ["Unflavored"], sizes: ["150g", "300g"],
    suggestedUsage: "Mix 1 scoop (3g) in 250ml of water 30 minutes before workout.",
    description: "Caalburn L-Arginine is a premium nitric oxide precursor that supports blood flow, muscle pumps and overall cardiovascular performance.",
    whenToTake: [{ label: "Pre Workout", text: "Take 30 minutes before your workout to maximize blood flow and pumps." }],
    features: [
      { title: "Nitric Oxide",   body: "Boosts NO production for massive muscle pumps." },
      { title: "Blood Flow",     body: "Improves nutrient delivery to working muscles." },
      { title: "3g Per Serving", body: "Optimal dose per serving." },
      { title: "Pure Formula",   body: "No fillers or artificial additives." },
      { title: "Endurance",      body: "Supports extended training capacity." },
      { title: "Easy Mix",       body: "Dissolves quickly in water." },
    ],
    nutritionRows: [
      { name: "Energy",     unit: "kcal", water: "15", milk: "—", rda: "—" },
      { name: "L-Arginine", unit: "g",    water: "3",  milk: "—", rda: "—" },
    ],
  },

  {
    id: "creatine",
    name: "Creatine",
    image: "/images/creatine copy.png",
    tagline: "100% Pure Micronized Creatine Monohydrate",
    subtitle: "Strength. Power. Muscle Recovery.",
    category: "Creatine",
    badge: "Pro Series",
    accentColor: "#f97316",
    protein: "0g",
    calories: "0",
    carbs: "0g",
    bcaa: "—",
    servingSize: "3g",
    flavors: ["Blueberry"],
    sizes: ["100g"],
    suggestedUsage: "Mix approximately 1 level 3 gram scoop with 150 ml water until the powder fully dissolves. Consume 30 minutes before or during your workout.",
    description: "Caalburn Creatine Monohydrate is 100% pure micronized creatine. It helps replenish ATP stores in muscles, increases strength, power, and delays fatigue. Ideal for athletes and gym-goers looking to improve workout intensity and muscle recovery.",
    whenToTake: [
      { label: "Pre Workout",  text: "Take 30 minutes before training to maximize strength and power output." },
      { label: "Intra Workout", text: "Can be consumed during workout for sustained energy." },
    ],
    features: [
      { title: "100% Pure Monohydrate", body: "Micronized for better absorption, no fillers." },
      { title: "ATP Replenishment",     body: "Quickly replenishes energy stores for explosive power." },
      { title: "Supports Strength & Power", body: "Helps increase workout intensity and muscle strength." },
      { title: "Muscle Recovery",       body: "Supports faster recovery between sets and sessions." },
      { title: "3g Per Serving",        body: "Precise serving as per label." },
      { title: "Zero Calories",         body: "No sugar, carbs, or calories." },
    ],
    nutritionRows: [
      { name: "Creatine Monohydrate", unit: "g",    water: "3.0", milk: "—", rda: "—" },
      { name: "Energy",               unit: "kcal", water: "0.08", milk: "—", rda: "0%" },
      { name: "Protein",              unit: "g",    water: "0.00", milk: "—", rda: "—" },
      { name: "Carbohydrates",        unit: "g",    water: "0.02", milk: "—", rda: "—" },
      { name: "Total Sugar",          unit: "g",    water: "0.015", milk: "—", rda: "—" },
      { name: "Added Sugar",          unit: "g",    water: "0.0015", milk: "—", rda: "—" },
      { name: "Total Fat",            unit: "g",    water: "0.00", milk: "—", rda: "0%" },
      { name: "Sodium",               unit: "mg",   water: "378", milk: "—", rda: "1.89%" },
    ],
    caution: "Not intended for use by persons under age 18. Not to be consumed by individuals with blood pressure issues, diabetic patients, pregnant women, or patients suffering from other medical conditions without consulting a healthcare expert or doctor.",
    storage: "Store in a cool & dry place, away from direct sunlight and moisture. Keep the container tightly closed."
},

  {
    id: "bcaa", name: "BCAA",
    image: "/images/bcaa.png",
    tagline: "Branched Chain Amino Acids 2:1:1", subtitle: "Fuel Muscles. Fight Fatigue.",
    category: "Pre Workouts", badge: "Pro Series", accentColor: "#a855f7",
    protein: "7g", calories: "30", carbs: "0g", bcaa: "7g", servingSize: "9g",
    flavors: ["Watermelon", "Mango", "Green Apple"], sizes: ["180g", "360g"],
    suggestedUsage: "Mix 1 scoop (9g) in 250ml cold water. Take during or after workout.",
    description: "Caalburn BCAA provides a scientifically validated 2:1:1 ratio of Leucine, Isoleucine and Valine — the three branched chain amino acids responsible for muscle protein synthesis, reducing muscle breakdown and speeding recovery.",
    whenToTake: [
      { label: "During Workout", text: "Sip during training to fuel muscles and prevent catabolism." },
      { label: "Post Workout",   text: "Take immediately after training to accelerate muscle recovery." },
    ],
    features: [
      { title: "2:1:1 Ratio",     body: "Optimal BCAA ratio for muscle growth and recovery." },
      { title: "7g BCAA",         body: "Per serving for maximum muscle protection." },
      { title: "Intra-Workout",   body: "Ideal for use during training sessions." },
      { title: "Reduces Fatigue", body: "Helps reduce exercise-induced fatigue." },
      { title: "Muscle Sparing",  body: "Prevents muscle breakdown (catabolism)." },
      { title: "Great Taste",     body: "Available in refreshing flavors." },
    ],
    nutritionRows: [
      { name: "BCAA (2:1:1)", unit: "g",    water: "7",    milk: "—", rda: "—"    },
      { name: "L-Leucine",    unit: "g",    water: "3.5",  milk: "—", rda: "—"    },
      { name: "L-Isoleucine", unit: "g",    water: "1.75", milk: "—", rda: "—"    },
      { name: "L-Valine",     unit: "g",    water: "1.75", milk: "—", rda: "—"    },
      { name: "Energy",       unit: "kcal", water: "30",   milk: "—", rda: "1%"   },
    ],
  },

  {
    id: "one-shot", name: "One Shot",
    image: "/images/one-shot.png",
    tagline: "All-In-One Pre-Workout", subtitle: "One Scoop. Total Performance.",
    category: "Pre Workouts", badge: "Pro Series", accentColor: "#ef4444",
    protein: "5g", calories: "60", carbs: "8g", bcaa: "3g", servingSize: "20g",
    flavors: ["Blue Raspberry", "Tropical Punch"], sizes: ["200g", "400g"],
    suggestedUsage: "Mix 1 scoop (20g) in 300ml cold water and consume 20-30 minutes before workout.",
    description: "Caalburn One Shot is the ultimate all-in-one pre-workout solution. One single scoop delivers everything you need — energy, focus, pump, endurance and strength — all in one perfectly dosed formula.",
    whenToTake: [{ label: "Pre Workout", text: "Take 20-30 minutes before workout for complete pre-workout benefits." }],
    features: [
      { title: "All-In-One",  body: "Complete pre-workout in a single scoop." },
      { title: "Energy",      body: "Sustained energy from natural and artificial sources." },
      { title: "Focus",       body: "Nootropic blend for laser sharp focus." },
      { title: "Pump",        body: "Vasodilators for skin-splitting muscle pumps." },
      { title: "Endurance",   body: "Beta-alanine for prolonged endurance." },
      { title: "Strength",    body: "Creatine blend for increased power output." },
    ],
    nutritionRows: [
      { name: "Energy",      unit: "kcal", water: "60",  milk: "—", rda: "2.1%" },
      { name: "Protein",     unit: "g",    water: "5",   milk: "—", rda: "8.3%" },
      { name: "Caffeine",    unit: "mg",   water: "250", milk: "—", rda: "—"    },
      { name: "Creatine",    unit: "g",    water: "3",   milk: "—", rda: "—"    },
      { name: "Beta-Alanine",unit: "g",    water: "2",   milk: "—", rda: "—"    },
    ],
  },

  {
    id: "thor", name: "Thor",
    image: "/images/thor.png",
    tagline: "God-Level Pre-Workout", subtitle: "Unleash Thunder In Every Rep",
    category: "Pre Workouts", badge: "Pro Series", accentColor: "#6366f1",
    protein: "4g", calories: "55", carbs: "7g", bcaa: "2.5g", servingSize: "18g",
    flavors: ["Thunder Berry", "Mango Storm", "Citrus Blast"], sizes: ["180g", "360g"],
    suggestedUsage: "Mix 1 scoop (18g) in 250ml cold water and consume 25-30 minutes before workout. Do not exceed 1 scoop per day.",
    description: "Caalburn Thor is the most powerful pre-workout formula in our lineup. Inspired by the god of thunder, Thor delivers god-level strength, focus and endurance to help you push past your limits every single session.",
    whenToTake: [{ label: "Pre Workout", text: "Take 25-30 minutes before your most intense training sessions." }],
    features: [
      { title: "God-Level Energy",  body: "Maximum energy formula for elite athletes." },
      { title: "Thunder Pump",      body: "Extreme nitric oxide formula for massive pumps." },
      { title: "Laser Focus",       body: "Advanced nootropic blend for ultimate mental clarity." },
      { title: "Unstoppable Power", body: "Power and strength matrix for maximum output." },
      { title: "Endurance Matrix",  body: "Extended endurance formula for longer training." },
      { title: "Elite Formula",     body: "Professional-grade ingredients at clinical doses." },
    ],
    nutritionRows: [
      { name: "Energy",       unit: "kcal", water: "55",  milk: "—", rda: "2.0%" },
      { name: "Protein",      unit: "g",    water: "4",   milk: "—", rda: "6.7%" },
      { name: "Caffeine",     unit: "mg",   water: "300", milk: "—", rda: "—"    },
      { name: "L-Citrulline", unit: "g",    water: "4",   milk: "—", rda: "—"    },
    ],
  },

  /* ── TABLETS & CAPSULES ─────────────────────────────── */
  {
    id: "omega-3", name: "Omega-3",
    image: "/images/omega-3.png",
    tagline: "Fish Oil 1000mg", subtitle: "Heart. Brain. Joint Health.",
    category: "Tablets Capsule", badge: "Pro Series", accentColor: "#f97316",
    protein: "—", calories: "9", carbs: "—", bcaa: "—", servingSize: "1 Capsule",
    packing: "60 Capsule", mrp: "₹799/-",
    flavors: [], sizes: ["60 Capsules"],
    suggestedUsage: "Take 1-2 capsules daily with meals or as recommended by a healthcare professional.",
    description: "Caalburn Omega-3 Fish Oil 1000mg provides a rich source of EPA and DHA essential fatty acids. These Omega-3s are critical for cardiovascular health, brain function, joint mobility and reducing inflammation throughout the body.",
    whenToTake: [{ label: "With Meals", text: "Take with meals to improve absorption and reduce any fishy aftertaste." }],
    features: [
      { title: "1000mg Fish Oil",   body: "High-potency omega-3 fish oil per capsule." },
      { title: "Heart Health",      body: "Supports healthy cholesterol levels and cardiovascular function." },
      { title: "Brain Function",    body: "DHA supports cognitive function and mental clarity." },
      { title: "Joint Support",     body: "Reduces joint inflammation and supports mobility." },
      { title: "Anti-Inflammatory", body: "Natural anti-inflammatory properties." },
      { title: "60 Capsules",       body: "30-60 day supply per bottle." },
    ],
    nutritionRows: [
      { name: "Fish Oil", unit: "mg",   water: "1000", milk: "—", rda: "—" },
      { name: "EPA",      unit: "mg",   water: "180",  milk: "—", rda: "—" },
      { name: "DHA",      unit: "mg",   water: "120",  milk: "—", rda: "—" },
      { name: "Energy",   unit: "kcal", water: "9",    milk: "—", rda: "—" },
    ],
  },

  {
    id: "multi-vitamin", name: "Multi Vitamin",
    image: "/images/multi-vitamin.png",
    tagline: "Complete Daily Multivitamin", subtitle: "Fill Every Nutritional Gap",
    category: "Tablets Capsule", badge: "Pro Series", accentColor: "#10b981",
    protein: "—", calories: "5", carbs: "—", bcaa: "—", servingSize: "1 Tablet",
    packing: "60 Tablets", mrp: "₹599/-",
    flavors: [], sizes: ["60 Tablets"],
    suggestedUsage: "Take 1 tablet daily with breakfast or as recommended by a healthcare professional.",
    description: "Caalburn Multi Vitamin is a comprehensive daily multivitamin designed for active individuals. Packed with 24 essential vitamins and minerals to support energy, immunity, recovery and overall health.",
    whenToTake: [{ label: "With Breakfast", text: "Take with your morning meal for best absorption and all-day energy support." }],
    features: [
      { title: "24 Vitamins",    body: "Complete spectrum of essential vitamins and minerals." },
      { title: "Energy Support", body: "B-vitamins support energy metabolism." },
      { title: "Immune Boost",   body: "Vitamins C, D and Zinc support immune function." },
      { title: "Antioxidants",   body: "Vitamins A, C and E provide antioxidant protection." },
      { title: "Bone Health",    body: "Calcium and Vitamin D support strong bones." },
      { title: "Daily Formula",  body: "Convenient once-daily tablet." },
    ],
    nutritionRows: [
      { name: "Vitamin A",   unit: "IU",  water: "2500", milk: "—", rda: "50%"  },
      { name: "Vitamin C",   unit: "mg",  water: "60",   milk: "—", rda: "100%" },
      { name: "Vitamin D3",  unit: "IU",  water: "400",  milk: "—", rda: "100%" },
      { name: "Vitamin B12", unit: "mcg", water: "6",    milk: "—", rda: "100%" },
      { name: "Zinc",        unit: "mg",  water: "7.5",  milk: "—", rda: "50%"  },
    ],
  },

  {
    id: "calcium", name: "Calcium",
    image: "/images/calcium.png",
    tagline: "Calcium + Vitamin D3", subtitle: "Strong Bones. Strong Performance.",
    category: "Tablets Capsule", badge: "Pro Series", accentColor: "#64748b",
    protein: "—", calories: "5", carbs: "—", bcaa: "—", servingSize: "1 Tablet",
    packing: "60 Tablets", mrp: "₹449/-",
    flavors: [], sizes: ["60 Tablets"],
    suggestedUsage: "Take 1-2 tablets daily with meals or as recommended by a healthcare professional.",
    description: "Caalburn Calcium with Vitamin D3 provides the essential minerals needed for strong bones, teeth and muscle function. Vitamin D3 enhances calcium absorption making this the most effective bone health supplement.",
    whenToTake: [{ label: "With Meals", text: "Take with meals to maximize calcium absorption in the body." }],
    features: [
      { title: "500mg Calcium",  body: "High dose elemental calcium per tablet." },
      { title: "Vitamin D3",     body: "Enhances calcium absorption significantly." },
      { title: "Bone Density",   body: "Supports and maintains healthy bone density." },
      { title: "Muscle Function",body: "Calcium is essential for muscle contraction." },
      { title: "Teeth Health",   body: "Supports strong and healthy teeth." },
      { title: "Easy Swallow",   body: "Smooth-coated tablet for easy swallowing." },
    ],
    nutritionRows: [
      { name: "Calcium",    unit: "mg", water: "500", milk: "—", rda: "50%"   },
      { name: "Vitamin D3", unit: "IU", water: "400", milk: "—", rda: "100%"  },
      { name: "Magnesium",  unit: "mg", water: "50",  milk: "—", rda: "12.5%" },
    ],
  },

  {
    id: "biotin", name: "Biotin",
    image: "/images/biotin.png",
    tagline: "High Potency Biotin 10000mcg", subtitle: "Hair. Skin. Nails. Energy.",
    category: "Tablets Capsule", badge: "Pro Series", accentColor: "#ec4899",
    protein: "—", calories: "2", carbs: "—", bcaa: "—", servingSize: "1 Tablet",
    packing: "60 Tablets", mrp: "₹499/-",
    flavors: [], sizes: ["60 Tablets"],
    suggestedUsage: "Take 1 tablet daily with a meal or as recommended by a healthcare professional.",
    description: "Caalburn Biotin 10000mcg is a high-potency biotin supplement that supports healthy hair growth, strong nails, clear skin and energy metabolism. Essential for anyone experiencing hair thinning or brittle nails.",
    whenToTake: [{ label: "With Meal", text: "Take once daily with any meal for consistent results over 8-12 weeks." }],
    features: [
      { title: "10000mcg Biotin",   body: "High-potency dose for visible results." },
      { title: "Hair Growth",       body: "Supports healthy hair growth and reduces hair fall." },
      { title: "Strong Nails",      body: "Strengthens brittle and weak nails." },
      { title: "Skin Health",       body: "Promotes clear, healthy skin." },
      { title: "Energy Metabolism", body: "Supports carbohydrate, fat and protein metabolism." },
      { title: "Once Daily",        body: "Convenient single daily tablet." },
    ],
    nutritionRows: [
      { name: "Biotin", unit: "mcg", water: "10000", milk: "—", rda: "33333%" },
      { name: "Energy", unit: "kcal",water: "2",     milk: "—", rda: "—"      },
    ],
  },

  {
    id: "l-arginine-tab", name: "L-Arginine",
    image: "/images/larginine.png",
    tagline: "L-Arginine 500mg Capsules", subtitle: "Pump. Circulation. Performance.",
    category: "Tablets Capsule", badge: "Pro Series", accentColor: "#f43f5e",
    protein: "—", calories: "5", carbs: "—", bcaa: "—", servingSize: "1 Capsule",
    packing: "60 Capsules", mrp: "₹549/-",
    flavors: [], sizes: ["60 Capsules"],
    suggestedUsage: "Take 2 capsules daily — 1 before workout and 1 before bed — or as recommended by a healthcare professional.",
    description: "Caalburn L-Arginine capsules provide a convenient way to supplement this essential amino acid. L-Arginine is a precursor to nitric oxide, supporting improved blood circulation, muscle pumps and cardiovascular health.",
    whenToTake: [
      { label: "Pre Workout", text: "Take before workout for improved pumps and blood flow." },
      { label: "Before Bed",  text: "Take before bed to support growth hormone production." },
    ],
    features: [
      { title: "500mg Per Capsule", body: "High-potency L-Arginine per capsule." },
      { title: "Nitric Oxide",      body: "Precursor to nitric oxide for better pumps." },
      { title: "Circulation",       body: "Improves blood flow and nutrient delivery." },
      { title: "Heart Health",      body: "Supports cardiovascular function." },
      { title: "GH Support",        body: "May support growth hormone release during sleep." },
      { title: "Convenient",        body: "Easy to take capsule form." },
    ],
    nutritionRows: [
      { name: "L-Arginine", unit: "mg",   water: "500", milk: "—", rda: "—" },
      { name: "Energy",     unit: "kcal", water: "5",   milk: "—", rda: "—" },
    ],
  },

  {
    id: "testosterone-booster", name: "Testosterone Booster",
    image: "/images/testosterone-booster.png",
    tagline: "Natural Testosterone Support", subtitle: "Strength. Vitality. Drive.",
    category: "Tablets Capsule", badge: "Pro Series", accentColor: "#b45309",
    protein: "—", calories: "5", carbs: "—", bcaa: "—", servingSize: "2 Capsules",
    packing: "60 Capsules", mrp: "₹899/-",
    flavors: [], sizes: ["60 Capsules"],
    suggestedUsage: "Take 2 capsules daily with meals or as recommended by a healthcare professional. For adults only.",
    description: "Caalburn Testosterone Booster is a natural herbal formula designed to support healthy testosterone levels in men. Contains a blend of clinically studied natural ingredients including Ashwagandha, Tribulus Terrestris and Zinc.",
    whenToTake: [{ label: "With Meals", text: "Take with breakfast and dinner for consistent testosterone support." }],
    features: [
      { title: "Natural Formula",        body: "Herbal blend with no synthetic hormones." },
      { title: "Ashwagandha",            body: "Adaptogen that supports testosterone and reduces cortisol." },
      { title: "Tribulus Terrestris",    body: "Traditional herb for testosterone support." },
      { title: "Zinc Complex",           body: "Essential mineral for testosterone production." },
      { title: "Strength Support",       body: "May support muscle strength and recovery." },
      { title: "Vitality",               body: "Supports energy, mood and overall male vitality." },
    ],
    nutritionRows: [
      { name: "Ashwagandha Extract", unit: "mg", water: "300", milk: "—", rda: "—"    },
      { name: "Tribulus Terrestris", unit: "mg", water: "250", milk: "—", rda: "—"    },
      { name: "Zinc",                unit: "mg", water: "15",  milk: "—", rda: "100%" },
      { name: "Vitamin D3",          unit: "IU", water: "400", milk: "—", rda: "100%" },
    ],
  },
];

/* ── Derived helpers ─────────────────────────────────────── */
export const CATEGORIES = [
  "All",
  "Whey Proteins",
  "Weight Gainer",
  "Mass Gainer",
  "Pre Workouts",
  "Tablets Capsule",
];

/* Grouped for Products dropdown in Navbar */
export const NAV_PRODUCT_GROUPS = [
  {
    label   : "Whey Proteins",
    catKey  : "Whey Proteins",
    children: PRODUCTS.filter((p) => p.category === "Whey Proteins").map((p) => ({ label: p.name, id: p.id })),
  },
  {
    label   : "Weight Gainer",
    catKey  : "Weight Gainer",
    children: PRODUCTS.filter((p) => p.category === "Weight Gainer").map((p) => ({ label: p.name, id: p.id })),
  },
  {
    label   : "Mass Gainer",
    catKey  : "Mass Gainer",
    children: PRODUCTS.filter((p) => p.category === "Mass Gainer").map((p) => ({ label: p.name, id: p.id })),
  },
  {
    label   : "Pre Workouts",
    catKey  : "Pre Workouts",
    children: PRODUCTS.filter((p) => p.category === "Pre Workouts").map((p) => ({ label: p.name, id: p.id })),
  },
  {
    label   : "Tablets Capsule",
    catKey  : "Tablets Capsule",
    children: PRODUCTS.filter((p) => p.category === "Tablets Capsule").map((p) => ({ label: p.name, id: p.id })),
  },
];
